import React from 'react';
import { Button, Col, Row, Spinner2, Text } from 'components';
import { Avatar } from 'components/Tailwindcss';
import { theme } from 'lib';
import {
  CandidateItem,
  DetailSection,
  PlayerName,
  StatItem,
  StatLabel,
  StatValue,
  StatusBadge
} from '../styles';

const POTMSection = ({
  potmData,
  loadingPOTM,
  game,
  teamPlayers,
  onOpenCreateModal,
  onOpenUpdateModal
}) => {
  return (
    <>
      <Text h4 bold marg="24px 0 16px">
        Player of the Match Poll
      </Text>

      <DetailSection>
        {loadingPOTM ? (
          <Col center pad="40px 0">
            <Spinner2 />
          </Col>
        ) : !potmData ? (
          <Col center pad="40px 0">
            <Text b2 col={theme.GREY_60} marg="0 0 16px">
              No Player of the Match poll found
            </Text>
            {game.status === 'scheduled' && (
              <Button
                text="Create POTM Poll"
                onClick={onOpenCreateModal}
                bg={theme.PRIMARY}
                wid="auto"
              />
            )}
          </Col>
        ) : (
          <Col noFlex wid="100%">
            <Row justifyContent="space-between" center marg="0 0 16px">
              <Col>
                <Row center gap="12px">
                  <StatusBadge
                    status={
                      potmData.status === 'open'
                        ? 'in-play'
                        : potmData.status === 'finished'
                          ? 'finished'
                          : 'scheduled'
                    }
                  >
                    {potmData.status}
                  </StatusBadge>
                  {game.status === 'scheduled' && (
                    <Button
                      text="Edit"
                      onClick={onOpenUpdateModal}
                      tiny
                      bg={theme.PRIMARY}
                      wid="auto"
                      pad="4px 12px"
                    />
                  )}
                </Row>
                <Text c2 col={theme.GREY_60} marg="4px 0 0">
                  Reward Points: {potmData.rewardPoints || 0}
                </Text>
              </Col>
              <Col end>
                <Text h4 bold>
                  {potmData.totalVotes || 0}
                </Text>
                <Text c2 col={theme.GREY_60}>
                  Total Votes
                </Text>
              </Col>
            </Row>

            {potmData.candidates && potmData.candidates.length > 0 ? (
              potmData.candidates.map((candidate, idx) => {
                const player =
                  typeof candidate.player === 'object'
                    ? candidate.player
                    : teamPlayers.find((p) => p._id === candidate.player);

                const displayName =
                  player?.name ||
                  (player?.firstName ? `${player.firstName} ${player.lastName}` : null) ||
                  'Unknown Player';

                return (
                  <CandidateItem key={candidate.player?._id || candidate.player || idx}>
                    <Row centerAll gap="12px">
                      <Avatar src={player?.photo} size={40}>
                        {displayName?.[0]}
                      </Avatar>
                      <PlayerName>{displayName}</PlayerName>
                    </Row>
                    <Row gap="24px">
                      <StatItem>
                        <StatValue>{candidate.votes || 0}</StatValue>
                        <StatLabel>Votes</StatLabel>
                      </StatItem>
                      <StatItem>
                        <StatValue>{candidate.rating?.toFixed(1) || '0.0'}</StatValue>
                        <StatLabel>Rating</StatLabel>
                      </StatItem>
                    </Row>
                  </CandidateItem>
                );
              })
            ) : (
              <Text center b2 col={theme.GREY_60}>
                No candidates listed
              </Text>
            )}
          </Col>
        )}
      </DetailSection>
    </>
  );
};

export default POTMSection;
